
<div class="column-flex">
    <div class="form-label">
        <div>
            {{ 'bar-label.dialog.title' | translate }}
        </div>
        <div class="channel-title" *ngIf="data.channelTitle">
            {{
                'graph.bar.dialog.channel.title'
                    | translate: { rowIndex: data.rowIndex, channelTitle: data.channelTitle }
            }}
        </div>
    </div>
    <form class="input-form" (input)="onBarLabelInput($event)">
        <app-input-with-error
            [legend]="'bar-label.dialog.title'"
            [inputValue]="barLabel"
            [inputHasErrors]="titleTooLong"
            (onInputUpdated)="barLabel = $event"
            [maxlength]="maxLabelLength"
            [showLegend]="false"></app-input-with-error>

        <ng-container>
            <div class="length-counter">{{ barLabel.length + '/' + maxLabelLength }}</div>
            <div class="error-message" *ngIf="titleTooLong">
                {{ 'bar-label.dialog.input.error.max-length-exceeded' | translate }}
            </div>
        </ng-container>
    </form>

    <div class="buttons-container">
        <div
            class="remove-button"
            (click)="removeLabel()"
            [ngClass]="{ 'remove-button-disabled': isRemoveDisabled() }">
            {{ 'bar-label.dialog.button.remove-label' | translate }}
        </div>

        <div class="cancel-save">
            <div class="cancel button" (click)="cancel()">
                {{ 'bar-label.dialog.button.cancel' | translate }}
            </div>
            <div class="save button" (click)="saveLabel()" [ngClass]="{ button_disabled: isSaveDisabled() }">
                {{ 'bar-label.dialog.button.save' | translate }}
            </div>
        </div>
    </div>
</div>

